import Vue from 'vue';
import { BootstrapVue, IconsPlugin, ModalPlugin, ToastPlugin } from 'bootstrap-vue';

import { VeeValidate } from '@validations';
import router from '@/router';
import store from '@/store';
import App from './App.vue';

// Global Components
import './global-components';

// Global Methods
import './global-methods';

// 3rd party plugins
import '@/libs/portal-vue';
import '@/libs/acl';
import UUID from 'vue-uuid';

// BSV Plugin Registration
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);

//UUID
Vue.use(UUID);

// import core styles
require('@core/scss/core.scss');

// import assets styles
require('@/assets/scss/style.scss');

require('@core/scss/vue/libs/vue-wizard.scss');
require('@core/scss/vue/libs/vue-select.scss');

VeeValidate.localize('sl');

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
